import React from "react";
import {
  AccordionDetails,
  Box,
  Grid,
  Paper,
  Typography
} from "@mui/material";
import {
  PageBox,
  SmallTextTypo,
  LargeTextTypo,
  ItemHeader
} from "./UserProfile.style";
import { useTranslation } from "react-i18next";
import { TabTitle } from "../../utils/GeneralFunctions";
import { useAuth } from "../../providers/Auth";

const UserProfile = () => {
  const auth = useAuth();
  const { t } = useTranslation();
  const creditingType = auth?.user?.creditingType;

  TabTitle(t("app.name") + " - " + t("user-profile.block1.header.page-title"));

  if (auth) {
    auth.refreshSession();
  }

  const mobileNumber =
    (auth?.user?.telephoneNumber &&
      auth?.user?.telephoneNumber
        .slice(-10)
        .replace(/\D+/g, "")
        .replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")) ||
    "";

  const authority = JSON.stringify(auth?.user?.authorities).toLocaleUpperCase();

  return (
    <>
      <PageBox>
        <Typography component="h3" variant="h3">
          {t("user-profile.block1.header.page-title")}
        </Typography>

        <Box pt={3}>
          <Paper variant="section" sx={{ padding: 0 }}>
            <ItemHeader>
              <Typography component="h2" variant="sectionTitle">
                {auth?.user?.userFullName}
              </Typography>
            </ItemHeader>
            <AccordionDetails>
              <Box pt={5}>
                <Grid container spacing={4}>
                  <Grid item md={2} sx={{ textAlign: "left" }}>
                    <SmallTextTypo>
                      {t("user-profile.block1.form.input-company")}
                    </SmallTextTypo>
                    <LargeTextTypo>{auth?.user?.company}</LargeTextTypo>
                  </Grid>
                  <Grid item md={2} sx={{ textAlign: "left" }}>
                    <SmallTextTypo>
                      {t("user-profile.block1.form.input-mobile")}
                    </SmallTextTypo>
                    <LargeTextTypo>{mobileNumber}</LargeTextTypo>
                  </Grid>
                  <Grid item md={4} sx={{ textAlign: "left" }}>
                    <SmallTextTypo>
                      {t("user-profile.block1.form.input-email")}
                    </SmallTextTypo>
                    <LargeTextTypo style={{ wordWrap: "break-word" }}>
                      {auth?.user?.email}
                    </LargeTextTypo>
                  </Grid>
                  <Grid item md={2} sx={{ textAlign: "left" }}>
                    <SmallTextTypo>
                      {t("user-profile.block1.form.input-status")}
                    </SmallTextTypo>
                    <LargeTextTypo>
                      {t(
                        "user-profile.block1.form.input-status." +
                          auth?.user?.status
                      )}
                    </LargeTextTypo>
                  </Grid>
                  <Grid item md={2} sx={{ textAlign: "left" }}>
                    <SmallTextTypo>
                      {t("user-profile.block1.form.input-type")}
                    </SmallTextTypo>
                    <LargeTextTypo>{creditingType}</LargeTextTypo>
                  </Grid>
                </Grid>
                <Grid
                  item
                  md={12}
                  sx={{ textAlign: "left", padding: "3rem 0 0 0" }}
                >
                  <SmallTextTypo>
                    {t("user-profile.block1.form.input-authorities")}
                  </SmallTextTypo>
                  <LargeTextTypo>{authority}</LargeTextTypo>
                </Grid>
                <Grid item md={12} sx={{ textAlign: "left" }}></Grid>
              </Box>
            </AccordionDetails>
          </Paper>
        </Box>
      </PageBox>
    </>
  );
};

export default UserProfile;
